import type { GuideId } from './guideAgents';

export const GUIDE_AGENT_TYPE = 'guide';

const ACTIVE_TAG_RE = /^\[active:(concierge|harry|wes)\]\n?/;

export function packGuideSettings(active: GuideId): string {
  return `[active:${active}]\n`;
}

export function unpackGuideSettings(stored: string | null | undefined): GuideId {
  const match = stored?.match(ACTIVE_TAG_RE);
  return (match?.[1] as GuideId) ?? 'concierge';
}

/** Infer active guide from legacy harry/wes enabled flags when no guide row exists. */
export function inferGuideFromLegacy(harryEnabled: boolean, wesEnabled: boolean): GuideId {
  if (harryEnabled && !wesEnabled) return 'harry';
  if (wesEnabled && !harryEnabled) return 'wes';
  if (harryEnabled && wesEnabled) return 'harry';
  return 'concierge';
}
